import axios from "../network/reuset";
import qs from "qs";

const getAccessad = {
  getAccessadList(params) {
    return axios.post(`/api/admin/accessad/list`, qs.stringify(params));
  },
};

export default getAccessad;
